/** Controlled state, page filters, Redux query params, picker `format` prop. */
export const APP_DATE_FORMAT = 'MM/DD/YYYY' as const;

/** Grid cells and compact table display. */
export const APP_DATE_DISPLAY_FORMAT = 'M/D/YYYY' as const;

/** Request bodies and ISO-like API fields. */
export const API_DATE_FORMAT = 'YYYY-MM-DD' as const;

/** A day written out in full, as a heading: `June 13, 2026`. */
export const APP_LONG_DATE_FORMAT = 'MMMM D, YYYY' as const;

/** A chart axis day label: `Jun 13`. */
export const APP_MONTH_DAY_FORMAT = 'MMM D' as const;
